<template>
  <div class="main-bg">
    <div class="frame">
      <div id="main" class="clearfix">
        <h2>修改密码</h2>
        <div id="content" class="tab-content">
          <div class="tab-pane" style="display: block;">
            <el-form class="form-wrapper" ref="ruleForm" :model="ruleForm" :rules="rules" :show-message="false"
              label-position="left" label-width="0">
              <div class="list clearfix">
                <el-form-item class="li" prop="account">
                  <label>用户账户：</label>
                  <el-input class="wrap" type="text" v-model="ruleForm.account" onpaste="return false"
                    maxlength="16"></el-input>
                  <form-message prop="account"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="oldPwd">
                  <label>旧密码：</label>
                  <el-input class="wrap" type="password" v-model="ruleForm.oldPwd" maxlength="16"
                    autocomplete="password" show-password @focus="focusInput($event, '密码（5-16位小写字母及数字组成）', 'oldPwd')" />
                  <form-message prop="oldPwd"></form-message>
                </el-form-item>
                <el-form-item class="li" prop="pwd">
                  <label>新密码：</label>
                  <el-input class="wrap" type="password" v-model="ruleForm.pwd" maxlength="16"
                    autocomplete="new-password" show-password />
                  <form-message prop="pwd"></form-message>
                </el-form-item>
                <el-form-item class="li">
                  <label for=""></label>
                  <div class="wrap"><a class="confirm_btn"> <input type="button" tabindex="6" value="确认提交"
                        @click="handleUpdate"> </a>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ajax_method, getLocParam } from '@/utils/utils.js';
import FormMessage from './formMessage.vue';
export default {
  components: {
    FormMessage
  },
  provide() {
    return {
      root: this
    }
  },
  data() {
    const inputStr = location.href.split('?')[1]
    const searchStr = inputStr ? decodeURIComponent(inputStr).replace(/\+/g, ' ') : ''
    const [proxyId, gameId, partId] = searchStr ? searchStr.split('/') : []
    return {
      formMessageRefs: [],
      checked: false,
      ruleForm: {
        account: null,
        oldPwd: null,
        pwd: null,
      },
      rules: {
        account: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '账号不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (value.length < 5 || value.length > 16) {
              const message = '账号长度为5-16位！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[A-Z]/.test(value)) {
              const message = '不能输入大写字符！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[\W]/g.test(value)) {
              const message = '账号只能由小写字母与数字组成！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
        oldPwd: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '密码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
        pwd: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            if (!value) {
              const message = '密码不能为空！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (value.length < 5 || value.length > 16) {
              const message = '密码长度为5-16位！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[A-Z]/.test(value)) {
              const message = '不能输入大写字符！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (/[\W]/g.test(value)) {
              const message = '密码只能由字母与数字组成！';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            if (this.ruleForm.oldPwd === value) {
              const message = '旧密码不能与新密码一致';
              this.showMessage({ type: 'warn', message }, { rule })
              return callback(new Error(message))
            }
            this.showMessage({ type: 'success' }, { rule })
            return callback()
          }
        }],
      },
      searchData: {
        proxyId,
        gameId,
        partId
      }
    }
  },
  methods: {
    getFormMessageRef(prop) {
      const formMessage = this.formMessageRefs;
      const current = formMessage.find(item => item.prop === prop);
      return current;
    },
    showMessage(data, { rule }) {
      const ref = this.getFormMessageRef(rule.field);
      if (!ref) return;
      ref.showMessage(data)
    },
    focusInput(event, msg, prop) {
      this.showMessage({ type: 'focus', message: msg }, { rule: { field: prop } })
    },
    handleUpdate() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        let sendData = {
          ...this.searchData,
          ...this.ruleForm
        }
        ajax_method({
          data: sendData,
          url: `/player/resetpwd`,
          type: 'POST',
          dataType: 'json',
          timeout: 60000,
          contentType: "application/json",
          success: (res) => {
            const resjson = JSON.parse(res)
            if (resjson.code === 1) {
              this.$message({
                type: 'success',
                message: resjson.message || '修改成功',
                duration: Infinity,
                showClose: true
              })
              this.$refs.ruleForm.resetFields();
              return
            }
            this.$message({
              type: 'error',
              message: resjson.message || '修改失败',
              duration: '3000',
            })
          },
          error: function (error) {
            this.$message({
              type: 'error',
              message: error.message,
              duration: '3000',
            })
          }
        })
      })
    }
  }
}
</script>
<style scoped>
@import "../assets/css/update.css";
</style>



// WEBPACK FOOTER //
// src/components/update.vue